module.exports = __webpack_public_path__ + "static/media/bg.db790882.png";